var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 10.8V9.2M4.25 5.25714C4.25 3.2312 5.85571 1.6 7.85 1.6C9.09228 1.6 10.1838 2.23296 10.8303 3.2M4.4 5.86667C3.74 5.86667 3.2 6.41524 3.2 7.08571V13.181C3.2 13.8514 3.74 14.4 4.4 14.4H11.6C12.26 14.4 12.8 13.8514 12.8 13.181V7.08571C12.8 6.41524 12.26 5.86667 11.6 5.86667H4.4Z",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    stroke: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock-open.e93f45eed649dbe3238810935ea940c4.svg";
export { ForwardRef as ReactComponent };